module.exports = __webpack_public_path__ + "static/media/logo-조아라@3x.7b6e8a54.png";